import type { ComponentPropsWithoutRef, FunctionComponent } from 'react'
import React from 'react'

import classnames from 'classnames'

import type { BadgeTheme } from '../../../../Badge'
import { Badge } from '../../../../Badge'
import styles from './ProductCardBadges.module.scss'

export const ProductCardBadges: FunctionComponent<BadgesProps> = ({
  className,
  badges,
  ...rest
}) => {
  if ((badges?.length ?? 0) === 0) {
    return null
  }

  return (
    <ul className={classnames(styles.list, styles.badges, className)} {...rest}>
      {badges?.map((badge) => (
        <li key={badge}>
          <Badge theme={badge as BadgeTheme} />
        </li>
      ))}
    </ul>
  )
}

///////// IMPLEMENTATION /////////

export type BadgesProps = {
  /**
   *  Optional list of badges.
   */
  badges?: Array<BadgeTheme> | null
  /**
   *  Optional styles
   */
  className?: string
} & ComponentPropsWithoutRef<'ul'>
